import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { MultiSelect } from 'react-multi-select-component'
import 'bootstrap/dist/css/bootstrap.min.css'
import _ from 'lodash'

const tableStyle = {
  backgroundColor: '#ffffff',
}

const divStyle = {
  paddingTop: '30px',
  width: '100%',
  overflowX: 'auto',
  whiteSpace: 'nowrap',
}

class Table extends React.Component {
  constructor(props) {
    super(props)
    if (_.size(props.employee) > 0) {
      this.state = {
        employee: props.employee,
        selectedUsers: [],
      }
    }
  }

  createTable() {
    const table = []
    const em = _.values(this.state.employee)[0]
    const nrofDays = new Date(em.year, em.month, 0).getDate()
    for (let i = 1; i <= nrofDays; i++) {
      const dw = new Date(em.year, em.month - 1, i).getDay()
      if (dw !== 0 && dw !== 6){
        table.push(<th key={i}>{i}</th>)
      }
    }
    return table
  }

  createTable2() {
    const table = []
    const em = _.values(this.state.employee)[0]
    const nrofDays = new Date(em.year, em.month, 0).getDate()
    for (let i = 1; i <= nrofDays; i++) {
      const dw = new Date(em.year, em.month - 1, i).getDay()
      let weekd = ''
      if (dw === 0){
        weekd = 'S'
      } else if (dw === 1) {
        weekd = 'M'
      } else if (dw === 2) {
        weekd = 'T'
      } else if (dw === 3) {
        weekd = 'W'
      } else if (dw === 4) {
        weekd = 'T'
      } else if (dw === 5) {
        weekd = 'F'
      } else {
        weekd = 'S'
      }
      if (dw !== 0 && dw !== 6){
        table.push(<th key={i}>{weekd}</th>)
      }
    }
    return table
  }

  createTableContent(employee) {
    const table = []
    const dict = {}
    const em = _.values(this.state.employee)[0]
    const nrofDays = new Date(em.year, em.month, 0).getDate()
    const vac = []
    let daysWorked = 0
    const hour = employee['working_hour']
    for (let j = 0; j < employee.vacations.length; j++){
      const y = employee.vacations[j]
      for ( let g = 0; g < y.days.length; g++){
        vac.push(employee.vacations[j].days[g])
        if (employee.vacations[j].type === 'rest'){
          dict[employee.vacations[j].days[g]] = 'C'
        } else if (employee.vacations[j].type === 'medical'){
          dict[employee.vacations[j].days[g]] = 'B'
        } else {
          dict[employee.vacations[j].days[g]] = 'L'
        }
      }
    }
    for (let i = 1; i <= nrofDays; i++) {
      const dw = new Date(em.year, em.month - 1, i).getDay()
      const h = em.month
      let de = ''
      if (i <= 9) {
        if (h <= 9) {
          de = '' + em.year + '-0' + h + '-0' + i
        } else {
          de = '' + em.year + '-' + h + '-0' + i
        }
      } else {
        if (h <= 9) {
          de = '' + em.year + '-0' + h + '-' + i
        } else {
          de = '' + em.year + '-' + h + '-' + i
        }
      }
      const q = '' + employee.id + i
      if (dw === 0 || dw === 6 || employee.public_holiday.includes(de) ){
        /*if (vac.indexOf(de) >= 0){
          table.push(<td key={q} style={{backgroundColor: '#f2f2f2'}}></td>)
        } else {
          table.push(<td key={q} style={{backgroundColor: '#f2f2f2'}}></td>)
        }*/
        if (dw !== 0 && dw !== 6){
          table.push(<td key={q} style={{backgroundColor: '#f2f2f2'}}></td>)
        }
      } else if (vac.indexOf(de) >= 0){
        if (dict[de] === 'L') {
          table.push(<td key={q} style={{backgroundColor: '#D4EFDF'}}>{dict[de]}</td>)
        } else if (dict[de] === 'B') {
          table.push(<td key={q} style={{backgroundColor: '#ffe6e6'}}>{dict[de]}</td>)
        } else {
          table.push(<td key={q} style={{backgroundColor: '#e6f2ff'}}>{dict[de]}</td>)
        }
      } else {
        daysWorked = daysWorked + 1
        table.push(<td key={q}>{hour}</td>)
      }
    }
    const totalHoursWorked = daysWorked * hour
    table.push(<td>{employee['vacations_days']}</td>)
    table.push(<td>{employee['vacations_hour']}</td>)
    table.push(<td>{totalHoursWorked}</td>)
    return table
  }

  renderHeader() {
    const monthNames = [ 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December' ]
    const em = _.values(this.state.employee)[0]
    //const nrofDays = new Date(em.year, em.month, 0).getDate()
    return <Fragment><th key="monthName">{monthNames[em.month - 1]} {em.year}</th>{this.createTable()}<th key="year_total" colSpan="3" style={{textAlign: 'center'}}>Total</th><th key="n_rest_medical_unpaid" colSpan="3" style={{textAlign: 'center'}}>Days off</th><th key="total3">Total days off</th></Fragment>
  }

  renderHeader2() {
    //const nrofDays = new Date(em.year, em.month, 0).getDate()
    return <Fragment><th key="name">Name</th>{this.createTable2()}<th key="total2">DO</th><th key="ore">HO</th><th key="ore_lucrate">HW</th><th key="no_rest">R</th><th key="no_medical">M</th><th key="no_unpaid">U</th><th key="total4">This year</th></Fragment>
  }

  renderData(team) {
    const myData = [].concat(Object.values(this.state.employee))
    return Object.keys(myData).map((key) => {
      const employee = myData[key]
      const j = '' + team + key
      let k = 0
      for (let j = 0; j < employee.team_ids.length; j++){
        const y = employee.team_ids[j]
        if (y.name === team){
          k = 1
        }
      }
      if (k === 1){
        return <tr key={j}><td>{employee['user_name']}</td>{this.createTableContent(employee)}<td>{employee['vacations_days_rest']}</td><td>{employee['vacations_days_medical']}</td><td>{employee['vacations_days_unpaid']}</td><td>{employee['vacations_year']}</td></tr>
      } else {
        return 
      }
    }
    )
  }

  renderTeam(team) {
    //const nrofDays = new Date(em.year, em.month, 0).getDate()
    return <div><h4>{team}</h4><table className="table table-bordered" style={tableStyle}><tbody><tr>{this.renderHeader()}</tr><tr>{this.renderHeader2()}</tr>{this.renderData(team)}</tbody></table></div>
  }

  renderOneUser(user) {
    const name = user.user_name
    return <div><h4>{name}</h4><table className="table table-bordered" style={tableStyle}><tbody><tr>{this.renderHeader()}</tr><tr>{this.renderHeader2()}</tr>{this.renderDataOneUser(user)}</tbody></table></div>
  }

  renderDataOneUser(user) {
    return <tr key={user.user_id}><td>{user['user_name']}</td>{this.createTableContent(user)}<td>{user['vacations_days_rest']}</td><td>{user['vacations_days_medical']}</td><td>{user['vacations_days_unpaid']}</td><td>{user['vacations_year']}</td></tr>
  }

  createTeams() {
    const table = []
    let em = _.values(this.state.employee)[0]
    const ems = _.values(this.state.employee)
    const teams = []
    let isadmin = false
    for (let f = 0; f < ems.length; f++){
      em = ems[f]
      if (em.user_request === true){
        isadmin = em.user_admin
      }
    }
    if (isadmin === true){
      for (let f = 0; f < ems.length; f++){
        em = ems[f]
        for (let j = 0; j < em.team_ids.length; j++){
          const y = em.team_ids[j]
          if (teams.includes(y.name) === false){
            teams.push(y.name)
          }
        }
      }
    } else {
      for (let f = 0; f < ems.length; f++){
        em = ems[f]
        if (em.user_request === true){
          for (let j = 0; j < em.team_ids.length; j++){
            const y = em.team_ids[j]
            if (teams.includes(y.name) === false){
              teams.push(y.name)
            }
          }
        }
      }
    }
    if (teams.length > 0){
      for (let i = 0; i < teams.length; i++) {
        table.push(this.renderTeam(teams[i]))
      }
    } else if (ems.length > 0){
      table.push(this.renderOneUser(ems[0]))
    } else {
      const textNonAdminManager = 'You are not an admin or a manager so you do not have access to statistics!'
      table.push(<h3>{textNonAdminManager}</h3>)
    }
    return table
  }

  renderSelectedUsersTable() {
    const tableContent = []
    for (let i = 0; i < this.state.selectedUsers.length; i++) {
      const emp = this.state.selectedUsers[i]
      tableContent.push(this.renderDataOneUser(this.state.employee[emp.value]))
    }

    return <div><table className="table table-bordered" style={tableStyle}><tbody><tr>{this.renderHeader()}</tr><tr>{this.renderHeader2()}</tr>{tableContent}</tbody></table></div>
  }

  renderTables() {
    if (this.state.selectedUsers.length > 0) {
      return <div style={divStyle}>{ this.renderSelectedUsersTable() }</div>
    } else {
      return <div style={divStyle}>{this.createTeams()}</div>
    }
  }

  render() {
    const monthNames = [ 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December' ]
    const em = _.values(this.state.employee)[0]
    return <div><div><a href="#" className="btn btn-secondary col-sm-1" onClick={() => this.handleToday(em)}>Today</a><a href="#" className="btn btn-secondary col-sm-1" onClick={() => this.handlePrev(em)} style={{marginLeft: '20px'}}>Previous</a>{ this.renderDownloadButton() }{ _.values(this.state.employee)[0].user_admin && this.renderSelectUsersButton() }<span className="col-sm-1 offset-sm-1"><b>{monthNames[em.month - 1]} {em.year}</b></span><a href="#" className="btn btn-secondary col-sm-1  offset-sm-1" onClick={() => this.handleNext(em)}>Next</a></div><div><h2>Legend</h2><ul style={{columns: '2'}}><li>DO - Days off</li><li>HO - Hours off</li><li>HW - Hours worked</li><li>R - Rest</li><li>M - Medical</li><li>U - Unpaid</li></ul></div><hr />{ _.values(this.state.employee)[0].user_admin && this.renderSelectUsers() }{ this.renderTables() }</div>
  }

  renderSelectUsersButton() {
    return <a href="#selectUsers" data-toggle="collapse" className="btn btn-secondary col-sm-2" style={{float: 'right', marginRight: '15px'}}>Select particular users</a>
  }

  renderDownloadButton() {
    const em = _.values(this.state.employee)[0]
    const ems = _.values(this.state.employee)
    let hreff = ''
    if (em.user_admin && this.state.selectedUsers.length > 0) {
      hreff = '/custom_statistics_excel/' + em.user_id.toString() + '/' + em.month.toString() + '/' + em.year.toString()

      // Add all selected users' ids to the URL
      hreff += `?users[]=${ems[this.state.selectedUsers[0].value].user_id}`
      for (let i = 1; i < this.state.selectedUsers.length; i++) {
        hreff += `&users[]=${ems[this.state.selectedUsers[i].value].user_id}`
      }
      return <a href={hreff} className="btn btn-secondary col-sm-2" style={{float: 'right'}}>Download</a>
    } else {
      hreff = '/statistics_excel/' + em.user_id.toString() + '/' + em.month.toString() + '/' + em.year.toString()
      return <a href={hreff} className="btn btn-secondary col-sm-2" style={{float: 'right'}}>Download</a>
    }
  }

  renderSelectUsers() {
    const options = []
    const ems = _.values(this.state.employee)
    for (let i = 0; i < ems.length; i++) {
      options.push({value: i, label: ems[i].user_name})
    }

    return <div className="collapse" id="selectUsers"><h4>Customize your statistics</h4><MultiSelect options={options} value={this.state.selectedUsers} onChange={(us) => this.setState({selectedUsers: us})} labelledBy={'Select users'}></MultiSelect><hr /></div>
  }

  handlePrev(em) {
    let mth = em.month
    let year = em.year
    if (em.month === 1) {
      mth = 12
      year = em.year - 1
    } else {
      mth = em.month - 1
    }
    fetch('/api/v1/users/' + em.user_id + '/get_vacation_dates/' + mth + '/' + year, {
      method: 'GET',
      dataType: 'JSON',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
    })
    .then((resp) => {
      return resp.json()
    })
    .then((data) => {
      this.setState({ employee: data })
    })
    .catch((error) => {
      console.error(error, 'catch the hoop')
    })
  }

  handleNext(em) {
    let mth = em.month
    let year = em.year
    if (em.month === 12) {
      mth = 1
      year = em.year + 1
    } else {
      mth = em.month + 1
    }
    fetch('/api/v1/users/' + em.user_id + '/get_vacation_dates/' + mth + '/' + year, {
      method: 'GET',
      dataType: 'JSON',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
    })
    .then((resp) => {
      return resp.json()
    })
    .then((data) => {
      this.setState({ employee: data })
    })
    .catch((error) => {
      console.error(error, 'catch the hoop')
    })
  }

  handleToday(em) {
    const d = new Date()
    const mth = d.getMonth() + 1
    const year = d.getFullYear()
    fetch('/api/v1/users/' + em.user_id + '/get_vacation_dates/' + mth + '/' + year, {
      method: 'GET',
      dataType: 'JSON',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
    })
    .then((resp) => {
      return resp.json()
    })
    .then((data) => {
      this.setState({ employee: data })
    })
    .catch((error) => {
      console.error(error, 'catch the hoop')
    })
  }
}

Table.propTypes = {
  employee: PropTypes.object,
}

export default Table
